const data = {
  pageName: "RoojoomFlows",
  roojoom: {
    flow: "WifiTroubleshooting",
    cli: "2111166299",
    otpCode: "1234",
    maxRetries: 30,
    interval: 1000,
    delay: 4
  },
  services: {
    roojoomTranslations: {
      url: "roojoom/translations",
      params: {}
    },
    roojoomCreateSession: {
      url: "roojoom/createSession",
      params: {}
    },
    roojoomGetInteraction: {
      url: "roojoom/getInteraction",
      params: {}
    },
    roojoomSendInteraction: {
      url: "roojoom/sendInteraction",
      params: {}
    }
  }
};

exports.data = data;
